(function (Config, Constantes) {
    'use strict';

    Config.defaultModo = 'V';
    Config.defaultModoRedirect = 'C';
    Config.defaultCombo = '1';
    Config.urlRedirect = window.location.origin + "/suscripcion/C/";
    Config.urlRedirectAccion = window.location.origin + "/suscripcion/A/";
    Config.urlBlocks = window.location.origin + '/views/paywall/blocks/';
    Config.urlLayouts = window.location.origin + '/views/paywall/layouts/';
    Config.dominioIngresar = window.location.origin + "/ingresar/P/1/?callback=";
    Config.urlAvatar = Constantes.Dominios.static + "/images/avatar/";
    Config.urlEdicionImpresa = Constantes.Dominios.lanacion + "/edicion-impresa";

    Config.SitioOrigen = Constantes.SitioOrigen;

    Config.HotjarRecordingTrigger = Constantes.HotjarRecordingTrigger;

    Config.HotjarHeatmapFormDocumento = Constantes.HotjarHeatmapFormDocumento;
    Config.HotjarHeatmapFormPersonales = Constantes.HotjarHeatmapFormPersonales;
    Config.HotjarHeatmapFormDomicilio = Constantes.HotjarHeatmapFormDomicilio;
    Config.HotjarHeatmapFormPago = Constantes.HotjarHeatmapFormPago;
    Config.HotjarHeatmapWall = Constantes.HotjarHeatmapWall;
   
    /*nombres provisorios*/
    /*Estos datos tiene que ser pisados por lo venga en Constantes */
    Config.COMBO_ACCESO_DIGITAL = parseInt(Constantes.COMBO_ACCESO_DIGITAL);// 5;
    Config.COMBO_ACCESO_DIGITAL_CREDENCIAL = parseInt(Constantes.COMBO_ACCESO_DIGITAL_CREDENCIAL); //6;
    Config.COMBO_NYT = parseInt(Constantes.COMBO_NYT); //7;
    /*
     * Por ahora solo voy a configurar los que vayan en el wall
     */
    /*
    Config.COMBO_PROMO_ACCESO_DIGITAL_CREDENCIAL = parseInt(Constantes.COMBO_PROMO_ACCESO_DIGITAL_CREDENCIAL); // 8;
    Config.COMBO_CALL_ACCESO_Y_CLUB = parseInt(Constantes.COMBO_CALL_ACCESO_Y_CLUB);
    Config.COMBO_CALL_ACCESO_Y_CLUB_50_OFF = parseInt(Constantes.COMBO_CALL_ACCESO_Y_CLUB_50_OFF);
    Config.COMBO_CALL_ACCESO_Y_CLUB_5_DESCUENTO = parseInt(Constantes.COMBO_CALL_ACCESO_Y_CLUB_5_DESCUENTO);
    */

    Config.COMBO_BONIFICADO = parseInt(Constantes.COMBO_BONIFICADO);// 3;

    Config.PRODUCTO_NOTA = parseInt(Constantes.PRODUCTO_NOTA); // 1;
    Config.PRODUCTO_PDF = parseInt(Constantes.PRODUCTO_PDF); //2;
    Config.ACCION_YA_TIENE_SUSCRIPCION = 1;

    Config.Routes = Constantes.Routes;
    Config.ExternalPaywall = Constantes.ExternalPaywall;

    Config.debugMode = false;
    Config.debugFlowData = {
        "A": {
            codeResult: "04",
            message: ""
        },
        "B": {
            codeResult: "04",
            message: ""
        },
        "C": {
            codeResult: "04",
            message: ""
        },
        "D": {
            codeResult: "05",
            message: ""
        },
        "E": {
            codeResult: "01",
            message: ""
        },
        "F": {
            codeResult: "20",
            message: ""
        }
    }

    Config.defaultUrl = window.location.origin + '/suscripcion/' + Config.defaultModo + '/' + Config.defaultSitioId + '/?';

    Config.canalesDeVenta = Constantes.CanalesDeVenta;

    // ==================================================
    // Modos permitidos
    // al agrtegar una entrada en el route automaticamente la configura como modo permitido
    // ==================================================      
    Config.Modos = [];
    for (var x in LN.Config.Routes) { LN.Config.Modos.push(LN.Config.Routes[x].modo); }

 
    // ==================================================
    // Campañas permitidas 
    // 373 : Campaña bonificada
    // 374 : Campaña paga
    // ==================================================  
    Config.campaniaBonificada = Constantes.campaniaBonificada;
    Config.campaniaPaga = Constantes.campaniaPaga;

    Config.Layouts = {
        WALL: {
            file: 'wall',
            class: 'paywall',
            css: ''
        },
        WALL_DINAMICO: {
            file: 'wall_dinamico',
            class: 'landing newsletter',
            css: ''
        },
        WALL_SUSCRIBIME: {
            file: 'wall_suscribirme',
            class: 'paywall suscribirme-principal',
            css: ''
        },
        PROCESAR_PAGO: {
            file: 'procesar_pago',
            class: 'paywall',
            css: ''
        },
        FULL_SCREEN: {
            file: 'full_screen',
            class: 'formularios',
            css: ''
        },
        FULL_SCREEN_DATOS: {
            file: 'full_screen_datos',
            class: 'formularios',
            css: ''
        },
        TWO_COLUMNS: {
            file: 'two_columns',
            class: 'login paywall-login',
            css: ''
        },
        LANDING: {
            file: 'landing',
            class: 'landing',
            css: ''
        },
        WALL_FULL_SCREEN: {
            file: 'wall_full_screen',
            class: 'paywall',
            css: ''
        },
        PLAN_INSUFICIENTE: {
            file: 'plan_insuficiente',
            class: 'paywall',
            css: ''
        },
        NO_TIENE_SUSCRIPCION:{
            file:'no_tiene_suscripcion',
            class: 'paywall',
            css: ''
        },
        PDF_SIN_SUSCRIPCION :{
            file: 'pdf_sin_suscripcion',
            class: 'paywall',
            css: ''
        },
        PDF_SUSCRIPTO_SIN_ACCESO :{
            file: 'pdf_suscripto_sin_acceso',
            class: 'paywall',
            css: ''
        }
    };

    // ==================================================
    // Constantes de steps o pasos
    // ==================================================  
    Config.Blocks = {
        WALL: {
            title: 'Acceso Digital',
            layout: 'WALL',
            file: '',
            class: '',
            forms: [],
            flow: [],
        },
        WALL_DINAMICO: {
            title: 'Acceso Digital',
            layout: 'WALL_DINAMICO',
            file: '',
            class: '',
            forms: [],
            flow: [],
        },
        WALL_SUSCRIBIME: {
            title: 'Acceso Digital',
            layout: 'WALL_SUSCRIBIME',
            file: '',
            class: '',
            forms: [],
            flow: [],
        },
        PDF_SIN_SUSCRIPCION: {
            title: 'Acceso Digital',
            layout: 'PDF_SIN_SUSCRIPCION',
            file: '',
            class: '',
            forms: [],
            flow: [],
        },
        PDF_SUSCRIPTO_SIN_ACCESO: {
            title: 'Acceso Digital',
            layout: 'PDF_SUSCRIPTO_SIN_ACCESO',
            file: '',
            class: '',
            forms: [],
            flow: [],
        },
        PROCESAR_PAGO: {
            title: 'Acceso Digital',
            layout: 'PROCESAR_PAGO',
            file: '',
            class: '',
            forms: [],
            flow: [],
        },
        PDF_MURO_SIN_COMBO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'pdf_muro_sin_combo',
            class: '',
            forms: [],
            flow: [],
        },
        FORMULARIO_DATOS_PERSONALES: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN_DATOS',
            file: 'formulario_datos_personales',
            forms: ['datos_personales'],
            class: '',
            flow: [],
        },
        INGRESAR_DNI: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN_DATOS',
            file: 'ingresar_dni',
            forms: ['datos_personales'],
            class: '',
            flow: [],
        },
        FORMULARIO_PAGO: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN_DATOS',
            forms: ['datos_envio', 'datos_tarjeta'],
            file: 'formulario_pago',
            class: '',
            flow: [],
        },
        FORMULARIO_ENVIO: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN_DATOS',
            forms: ['datos_envio', 'datos_tarjeta'],
            file: 'formulario_envio',
            class: '',
            flow: [],
        },
        CONFIRMACION_COMBO_1: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN',
            file: 'confirmacion_combo_1',
            forms: [],
            class: 'custom-felicitaciones',
            flow: [],
        },
        CONFIRMACION_COMBO_2: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN',
            file: 'confirmacion_combo_2',
            forms: [],
            class: 'custom-felicitaciones',
            flow: [],
        },
        VALIDAR_PINES: {
            title: 'Acceso Digital',
            layout: 'WALL_FULL_SCREEN',
            file: 'validar_pines',
            forms: [],
            class: 'pin',
            flow: []
        },
        VALIDAR_PINES_GRACIAS: {
            title: 'Acceso Digital',
            layout: 'WALL_FULL_SCREEN',
            file: 'validar_pines_gracias',
            forms: [],
            class: 'pin',
            flow: []
        },
        FALTA_DE_PAGO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'falta_de_pago',
            forms: [],
            class: '',
            flow: [],
        },
        YA_TIENE_CUENTA: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'ya_tiene_cuenta',
            forms: [],
            class: '',
            flow: [],
        },
        PRIMER_ACCESO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'primer_acceso',
            forms: [],
            class: '',
            flow: [],
        },
        TIENE_DEUDA: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'tiene_deuda',
            forms: [],
            class: '',
            flow: [],
        },
        PLAN_INSUFICIENTE: {
            title: 'Acceso Digital',
            layout: 'PLAN_INSUFICIENTE',
            file: '',
            forms: [],
            class: '',
            flow: [],
        },
        ASOCIAR_TARJETA: {
            title: 'Asociar Tarjeta',
            layout: 'TWO_COLUMNS',
            file: 'asociar_tarjeta',
            forms: [],
            class: '',
            flow: [],
        },
        MOSTRAR_ERROR: {
            title: 'Error',
            layout: 'TWO_COLUMNS',
            file: 'mostrar_error',
            forms: [],
            class: '',
            flow: [],
        },
        YA_COMPRO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'ya_compro',
            forms: [],
            class: '',
            flow: [],
        },
        NO_TIENE_SUSCRIPCION: {
            title: 'Acceso Digital',
            layout: 'NO_TIENE_SUSCRIPCION',
            file: '',
            forms: [],
            class: '',
            flow: [],
        },
        LANDING: {
            title: 'Acceso Digital',
            layout: 'LANDING',
            file: '',
            forms: [],
            class: '',
            flow: [],
        },
        DOMICILIO_NO_EXISTE: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'domicilio_no_existe',
            forms: [],
            class: '',
            flow: [],
        },
        MOSTRAR_TRIBUNO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'mostrar_tribuno',
            forms: [],
            class: '',
            flow: [],
        },
        MOSTRAR_UNO: {
            title: 'Acceso Digital',
            layout: 'TWO_COLUMNS',
            file: 'mostrar_uno',
            forms: [],
            class: '',
            flow: [],
        },  
        YA_TIENE_FACEBOOK: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN',
            file: 'ya_tiene_facebook',
            forms: [],
            class: 'fbInsta custom-felicitaciones',
            flow: [],
        },  
        CONFIRMACION_BONIFICADO_FACEBOOK: {
            title: 'Acceso Digital',
            layout: 'FULL_SCREEN',
            file: 'confirmacion_bonificado_facebook',
            forms: [],
            class: 'fbInsta custom-felicitaciones',
            flow: [],
        }  
  };

  //Config.MostrarBotonSWG = Constantes.MostrarBotonSWG;

})(LN.Config, window.config.Constantes);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/config.js